const prepareShow = guest => {
  return guest
}

const prepareSearch = (search) => {
  search.generic = search.generic
  return search
}

export default {
  prepareShow,
  prepareSearch,
  doFilterSearch () {
    this.setPage(1)
  },
  doClearSearch () {
    this.search.generic = null
    this.doLoadAll()
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/guest/index/resources/methods.js